import {
    FETCH_CREATE_USERS_REQUEST,
    FETCH_CREATE_USERS_SUCCESS,
    FETCH_CREATE_USERS_FAILURE,
} from '../../actions/users/create-user-action';

const initialState = {
    createdUser: null,
    isLoading: false,
    error: null,
};

const CLEAR_DATA = "CLEAR_DATA";
const CreateUserReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_CREATE_USERS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_CREATE_USERS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                createdUser: { ...action.payload[0] },
            };
        case FETCH_CREATE_USERS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CLEAR_DATA:
            return {
                ...initialState
            };
        default:
            return state;
    }
};

export default CreateUserReducer;